import React from 'react';
import * as PropTypes from 'prop-types';
import {
  ActivityCard,
  Highlight,
  CardActionArea,
  ActivityIcon,
  InfoContainer,
  Title,
  LogButton,
  CardActions,
} from './elements';
import Lab010 from 'dc/Lab010';
import { useText } from 'common/hooks';

function ActCardUnavailable(props) {
  const t = useText();

  return (
    <ActivityCard className={props.className}>
      <Highlight color={'#C5C7CF'} />
      <CardActionArea>
        <ActivityIcon
          icon={`https://static.ducky.eco/SVGIcons/activities/act_placeholder.png`}
        />
        <InfoContainer>
          <Title>{t('challenge.activities.no_longer_available')}</Title>
          <Lab010 icon="icon-leaf" color="#E2E3E7">
            {'-'}
          </Lab010>
        </InfoContainer>
      </CardActionArea>
      <CardActions>
        <LogButton disabled checked={false} />
      </CardActions>
    </ActivityCard>
  );
}

ActCardUnavailable.propTypes = {
  className: PropTypes.string,
};

export default ActCardUnavailable;
